import { component$ } from "@builder.io/qwik";
import { cn } from "~/lib/cn";
import { cva, type VariantProps } from "class-variance-authority";

const variants = cva("", {
  variants: {
    color: {
      default: "text-orange-200",
      brand: "text-brand-700",
    },
  },
  defaultVariants: {
    color: "default",
  },
});

type ProfileSectionHeaderProps = {
  text: string;
  class?: string;
} & VariantProps<typeof variants>;

export const ProfileSectionHeader = component$<ProfileSectionHeaderProps>(
  ({ text, color, ...props }) => {
    return (
      <div
        class={cn(
          "mb-2 flex items-center gap-2",
          variants({ color }),
          props.class,
        )}
      >
        <svg
          width="32"
          height="2"
          viewBox="0 0 32 2"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M2 1 L30 1"
            stroke="currentColor"
            stroke-width="2"
            fill="none"
            stroke-linecap="round"
          />
        </svg>
        <span class="text-tertiary text-sm">{text}</span>
      </div>
    );
  },
);
